module.exports = __webpack_public_path__ + "static/media/earlexFlyer3Front.91de9b62.jpg";